import dynamicKanbanReducer from '@/containers/dynamic-kanban/store';
import taskManagerReducer from '@/containers/task-manager/store';
import salesDashboard from '@/views/Dashboard/store';
import crmCustomerDetails from '@/views/customer-management/customer-detail/store';
import crmCustomers from '@/views/customer-management/customers/store';
import menuBoardReducer from '@/views/menu-manager/menu-board/store';
import menuDialogReducer from '@/views/menu-manager/menu-dialog/store';
import menuListReducer from '@/views/menu-manager/menu-list/store';
import orderManagementReducer from '@/views/ordermanagement/Orders/store';
import navManagerReducer from '@/views/settings/system-settings/nav-manager/store';
import { combineReducers } from 'redux';
import auth from './auth';
import base from './base';
import businessInfo from './business-info/business-info-slice';
import dataSource from './data-source/data-source-slice';
import firebaseConfig from './firebase-config/firebase-config-slice';
import locale from './locale/localeSlice';
import notification from './notification/notification-slice';
import pageConfig from './page-config/page-config-slice';
import systemConfig from './system-config/system-config-slice';
import theme from './theme/themeSlice';

const rootReducer = combineReducers({
  theme,
  auth,
  base,
  locale,
  systemConfig,
  dataSource,
  businessInfo,
  notification,
  pageConfig,
  firebaseConfig,
  menuList: menuListReducer,
  orderManagement: orderManagementReducer,
  menuDialog: menuDialogReducer,
  menuBoard: menuBoardReducer,
  crmCustomerDetails: crmCustomerDetails,
  crmCustomers: crmCustomers,
  salesDashboard: salesDashboard,

  navManager: navManagerReducer,

  taskManager: taskManagerReducer,

  dynamicKanban: dynamicKanbanReducer,
});

export default rootReducer;
